<template>
    <main class="au-view au-404 bg-black py-8">
        <div class="container-fluid">
            <div class="row">
                <div class="col text-center text-white">
                    <h2 class="mb-8">You did it! You reached the end of the universe!</h2>
                    <h6>This is either because:</h6>
                    <ul class="list-unstyled">
                        <li>You have been logged out or</li>
                        <li>The page you are trying to reach is gone</li>
                    </ul>

                    <p>
                        <br />
                        <a
							href="#" @click.prevent="signInClick()"
							id="signinbutton"
						>
							Sign in
						</a> to access your Public Profile.
                    </p>
                    <p>
                        <a href="/">Click here</a> to return to the Alpha Universe homepage.
                    </p>
                </div>
            </div>
        </div>
    </main>
</template>

<script>
import { PROFILE_CONSTANTS } from '@/PROFILE_CONSTANTS';

export default {
    name: '404',
    methods: {
        signInClick() {
            $cookies.set(
                'au_loginredirect',
                PROFILE_CONSTANTS.EDIT_URL,
				null,
				'/',
				null,
				true
			);

            window.location.href = PROFILE_CONSTANTS.LOGIN_REDIRECT;
        },
    },
};
</script>

<style lang="scss">
@import '../assets/scss/all.scss';

// styles from AU page
// body {
// 	min-height: none!important;
// 	background-color: $sony-black;
// }
// footer {
// 	width: 100%;
// 	bottom: 0;
// 	position: fixed;
// }
// @media screen and (max-width: 767px) {
// 	footer {
// 		bottom: auto;
// 		position: unset;
// 		width: auto !important;
// 	}
// }
</style>
